import { Map, List, fromJS } from 'immutable';
import api from '@synergycms_core/utils/api';
import { ParamsParser } from '@synergycms_core/utils';
import { roomCanAddService, boardCanAddService } from './availUtils';
import { AVAIL_LIFETIME, SERVICE_TYPE_PER_NIGHT, SERVICE_TYPE_PER_PERSON_NIGHT } from '../../config/constants';

const setErrorServices = (filteredHotelsIds, paramsQuery, lastRequest) => {
  const result = filteredHotelsIds.reduce(
    (response, hotelId) =>
      response.setIn([hotelId, paramsQuery], Map({ last_request: lastRequest, response: Map({ success: false }) })),
    Map()
  );
  return Promise.resolve(result);
};

export const filterAvailServices = (services = List(), roomRatesSelected) =>
  services.filter(service => {
    let validService = !service.get('has_closed_price');
    if (validService) {
      validService = roomRatesSelected.some(
        block => roomCanAddService(service)(block) && boardCanAddService(service)(block)
      );
    }
    return validService;
  });


/**
 * Función que filtra los servicios que no tienen disponibilidad en base al criterio
 * del cliente.
 * 
 * Normalmente el backend ya se encarga de filtrar los servicios que no tienen disponibilidad,
 * pero en el caso de los servicios por noche con cupo, el backend no lo hace y es necesario filtrar
 * los servicios que no tienen disponibilidad.
 */
export const filterUnavailableServices = (services = List(), reservationRequest) => {
  services.forEach((service, key) => {
    const serviceType = service.get('type').toUpperCase();
    const isNight = [SERVICE_TYPE_PER_NIGHT].includes(serviceType);
    const isPersonNight = [SERVICE_TYPE_PER_PERSON_NIGHT].includes(serviceType);
    const worksWithQuota = !!service.get('works_with_quota', false);

    // Estos son los casos que hay que controlar
    if (worksWithQuota && (isNight || isPersonNight)) {
      const worksWithQuotaTime = service.get('works_with_quota_time', false);

      let isInvalid = false;
      service.get('days', List()).forEach((day, dayKey) => {

        const limitCriteria = isNight ? 
          reservationRequest.get('blocks', List()).size : 
          reservationRequest.get('blocks', List()).reduce((acc, block) => {
            return acc + (block.get('adults', 0) + block.get('childs', 0));
          }, 0);

        // Si es por horas y tipo noche, verificamos que hay quota para todos los bloques
        if (worksWithQuotaTime) {
          // Al trabajar por horas, si un dia no tiene quota en ninguna hora, se elimina el servicio
          isInvalid =  day.get('quotas_time').every((quotaTime, quotaTimeKey) => {
            const quota = quotaTime.get('quota', 0);
            return quota < limitCriteria;
          });

        } else {
            //  Al trabajar por noche si una sola noche no tiene quota, se elimina el servicio
            const dailyQuota = day.get('quota', 0);
            isInvalid = dailyQuota < limitCriteria;
        }

      });

      if(isInvalid) {
        services = services.delete(key);
      }

    }
    
  });

  return services;
}

export default {
  RESET_AVAIL: () => {
    return (dispatch, getState) => {
      const store = getState();
      return store.getIn(['customer', 'current_hotel']);
    };
  },
  GET_ASYNC: () => {
    return (dispatch, getState) => {
      const store = getState(),
        customerState = store.get('customer'),
        customerSearchParams = customerState.getIn(['params', 'params']),
        serviceSearchParams = Map({
          date: customerSearchParams.get('date'),
          stay_length: customerSearchParams.get('stay_length'),
          daily_details: true
        }),
        paramsQuery = ParamsParser.paramsToQuery(serviceSearchParams);

      if (paramsQuery) {
        let hotelIds;
        if (store.getIn(['customer', 'current_hotel'])) {
          hotelIds = List([store.getIn(['customer', 'current_hotel'])]);
        } else {
          hotelIds = store.getIn(['customer', 'current_hotels']);
        }
        const availability = store.get('availServices');
        const now = +new Date();

        const filteredHotelsIds = List(hotelIds).reduce((hotels, hotelId) => {
          const lastRequest = availability.getIn([hotelId, paramsQuery, 'last_request']);
          if (
            availability.getIn([hotelId, paramsQuery], false) === false ||
            (Number.isFinite(lastRequest) && lastRequest + AVAIL_LIFETIME <= now)
          ) {
            return hotels.push(hotelId);
          }
          return hotels;
        }, List());
        const lastRequest = +new Date();
        if (filteredHotelsIds.size) {
          return api.get('availability/servicesBuscador2', { q: paramsQuery }, filteredHotelsIds.toJS()).then(availResponse => {
              if (availResponse.success !== false) {
                return fromJS(availResponse).reduce(
                  (availServices, services, hotelId) =>
                    availServices.setIn(
                      [hotelId, paramsQuery],
                      Map({
                        last_request: lastRequest,
                        response: services.get('success') === false ? services : services.get(0)
                      })
                    ),
                  Map()
                );
              } else {
                return setErrorServices(filteredHotelsIds, paramsQuery, lastRequest);
              }
            })
            .catch(() => {
              return setErrorServices(filteredHotelsIds, paramsQuery, lastRequest);
            });
        }
        return Promise.resolve();
      }
      return Promise.resolve();
    };
  }
};
